import Decimal from "decimal.js";

export const convertAmountToPercent = (value, walletLimitDecimal) => {
  let rawValue = String(value || "").trim();
  if (!rawValue) return null;
  if (rawValue.endsWith(".")) rawValue = rawValue.slice(0, -1);

  const valueDecimal = new Decimal(rawValue);
  if (valueDecimal.isNaN()) return null;

  return valueDecimal
    .times(100)
    .div(walletLimitDecimal)
    .toFixed(2)
    .replace(/\.?0+$/, "");
};

export const convertPercentToAmount = (value, walletLimitDecimal) => {
  let rawValue = String(value || "").trim();
  if (!rawValue) return null;
  if (rawValue.endsWith(".")) rawValue = rawValue.slice(0, -1);

  const percentDecimal = new Decimal(rawValue);
  if (percentDecimal.isNaN()) return null;

  return percentDecimal
    .times(walletLimitDecimal)
    .div(100)
    .toFixed(2)
    .replace(/\.?0+$/, "");
};
